<template>
  <footer class="footer" :style="{backgroundColor}">
    <div class="container">
      <div class="row footer-main">
        <div class="col-sm-12 info">
          <p :style="{ color}" v-html="footerMessage"></p>
        </div>
        <div v-if="showMenu" class="col-sm-12 menu">
            <span v-for="menu in dynamicData.menu"
                v-bind:key="menu.title">
              <a target="_self"
                :style="{color}"
                :href="menu.url"
                v-track-event:link="{ url: menu.url }"
                class="nav-link">{{menu.title}}</a>
            </span>
          </div>
        </div>
      </div>
      <div class="row footer-secondary">
        <div class="col-sm-12">
          <p :style="{backgroundColor, color}" class="footer-copy">My Portfolio &copy; {{ currentYear }}</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      currentYear: new Date().getFullYear()
    }
  },
  computed: {
    ...mapState('app', ['dynamicData', 'isLoading']),
    footerMessage: function () {
      return this.dynamicData.footer ? this.dynamicData.footer.footerMsg : ''
    },
    backgroundColor: function () {
      return this.dynamicData.footer ? this.dynamicData.footer.backgroundColor : '#FFFFFF'
    },
    color: function () {
      return this.dynamicData.footer ? this.dynamicData.footer.color : '#000000'
    },
    showMenu: function () {
      return this.dynamicData.footer ? this.dynamicData.footer.menu : false
    }
  }
}

</script>

<style lang="scss" scoped>
.footer {
  background-color: $color-base-white;
  color: white;
  flex: 0 0 auto;
  -webkit-flex: 0 0 auto;
  .footer-main {
    margin-bottom: 2em;
  }
  .info {
    padding-top: 1em;
    text-align: center;
  }

  .menu span {
    display: inline-block;
  }


  a {
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
    &:focus {
      text-decoration: underline;
    }
  }
  .footer-copy{
    color: #afb0b1;
  }
}
</style>
